// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__3tpI_","fullScreen":"Error_fullScreen__31bpk"};